import {gql, DocumentNode} from "@apollo/client";
import {buildFieldTree, treeToGraphQL} from "./dynamic-query-builder";

export const DEFAULT_JOB_FIELDS = ["jobId", "jobNumber", "jobStatus", "driver.driverCode", "order.orderId"];

export function buildJobQuery(fields?: string[]): DocumentNode {
  const fieldTree = buildFieldTree(fields ?? DEFAULT_JOB_FIELDS);
  const fieldsGraphQL = treeToGraphQL(fieldTree, "                                ");

  return gql(/* GRAPHQL */ `
                    query GetJob($filter: JobFilter, $sort: [JobSortInput], $offset: Int, $limit: Int) {
                        searchJobs(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
                            items {
${fieldsGraphQL}
                            }
                            nextToken,
                            total
                        }
                    }
                `);
}
